import { render, staticRenderFns } from "./account-receivables-overview.vue?vue&type=template&id=663f3231"
import script from "./account-receivables-overview.vue?vue&type=script&lang=js"
export * from "./account-receivables-overview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports